import styled from 'styled-components';

import { breakpoints } from 'definitions';

// Las tres fechas de las etapas van en un solo renglón: son cortas, se leen
// mejor comparadas entre sí y el modal deja de ser una columna larga.
// En tablet vuelven a apilarse para que no queden ilegibles.
export const StagesRow = styled.div`
	display: flex;
	gap: 1.6rem;
	align-items: flex-start;

	> * {
		flex: 1 1 0;
		min-width: 0;
	}

	${breakpoints.tablet} {
		flex-direction: column;
		gap: 0;
	}
`;
